const { formatMoney } = require("./utils/price")
const { $Q, $Qll } = require("./utils/query-selector")
const { stringToHTML } = require("./utils/to-html")
const { toggleDataActive, dataToggle } = require("./utils/toggle-dataset")

module.exports = {
  stringToHTML,
  formatMoney,
  toggleDataActive,
  dataToggle,
  $Q,
  $Qll
}